import styled from "styled-components";

const ReportCard =styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
    width: 100%;
    min-height: 70px;

    margin: 5px 5px;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: var(--card-background);
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    &:hover{
        background: var(--border-color);
    }

    .card-body{
        font-weight: bold;
        color: unset;
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .card-footer{
        font-size: 0.7rem;
        color: unset;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .icon-options{
        position: absolute;
        top: -4px;
        right: -8px;
    }

    .icon-favorite{
        position: absolute;
        top: 3px;
        left: 5px;
    }

    flex: 0 0 23%;
                
    @media(max-width: 1200px){
        flex-basis: 31%;
    }
    
    @media(max-width: 1000px){
        flex-basis: 46%;
    }

    @media(max-width: 600px){
        flex-basis: 100%;
    }
`;

export default ReportCard;
